import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Wrapper, Dots} from './Images.style';
import ImagesDot from './ImageDot';

export default class Images extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selected: 0
    };
    this.selectImage = this.selectImage.bind(this);
    this.setImageInterval = this.setImageInterval.bind(this);
  }

  componentDidMount() {
    const {images} = this.props;
    if (images && images.length > 1) {
      this.setImageInterval();
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  setImageInterval() {
    this.interval = setInterval(() => this.setState({
      selected: this.state.selected === this.props.images.length -1 ? 0 : this.state.selected + 1
    }), 3000);
  }

  selectImage(selected) {
    this.setState({selected});
    clearInterval(this.interval);
    setTimeout(() => this.setImageInterval(), 1000);
  }
  render() {
    const {images} = this.props;
    const renderDots = images.length > 1 && images.map((img, i) => {
      if (!img.url) {
        return;
      }
      return (
        <ImagesDot
          key={img.url + i}
          number={i}
          callback={this.selectImage}
        />
      );
    });
    return (
      <Wrapper url={images[this.state.selected].url}>
        <Dots>{renderDots}</Dots>
      </Wrapper>
    );
  }
}
Images.propTypes = {
  images: PropTypes.array.isRequired
};



// WEBPACK FOOTER //
// ./containers/LightHomePage/Images.js